var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VApp',{attrs:{"id":"inspire"}},[_c('NavigationDrawer'),_c('ToolBar',{attrs:{"mass-text-icon":_vm.massTextIcon}}),_c('VContent',[_c('VContainer',{ref:"container",attrs:{"fluid":""}},[_c('RouterView')],1)],1),_c('MessageDrawer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }